import styled from 'styled-components'

const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 17px;
`

const MailHeading = styled.h2`
  color: ${props => props.theme.email.full.color};
  font-size: 18px;
  font-weight: bold;
  height: 28px;
  line-height: 32px;
  margin-bottom: 10px;
  width: 100%;
`

const MailIcon = styled.img`
  margin-right: 12px;

`

const MailText = styled.div`
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 15px;
`

const DivThemeColor = styled.div`
  color: ${props => props.theme.email.full.color};
  display: inline-block;
  font-weight: bold;
`

const AddressContainer = styled.div`
  width: 100%;
  display: block;
`

const InboxLinksContainer = styled.div`
  margin-top: 15px;
`

export { Header, MailHeading, MailIcon, MailText, DivThemeColor, AddressContainer, InboxLinksContainer }
